import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 32 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export default function About() {
  return (
    <section id="about" className="relative bg-[#0a1f33] py-20 sm:py-28 scroll-mt-16 overflow-hidden" data-testid="about-section">
      <img
        src="/uk-map.png"
        alt=""
        aria-hidden="true"
        className="absolute right-0 top-1/2 -translate-y-1/2 h-[130%] w-auto opacity-60 img-feather select-none pointer-events-none"
      />

      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <motion.h2
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          custom={0}
          className="font-display font-extrabold uppercase leading-[1.05] tracking-tight text-4xl sm:text-5xl text-white"
        >
          About LeakLock
        </motion.h2>
        <motion.span variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} custom={0} className="block w-12 h-1 bg-[#1c9ce8] mt-6" />
        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          custom={1}
          className="mt-7 text-slate-300 leading-relaxed max-w-xl space-y-5"
          data-testid="about-body"
        >
          <p>
            LeakLock is a UK-based plumbing technology company developing smarter
            ways to reduce installation uncertainty and avoidable water damage.
          </p>
          <p>
            Verix H₂O is our first product, built around a simple idea:{" "}
            <span className="text-[#2aa7ec] font-semibold">See it. Hear it. Feel it.</span>
          </p>
          <p>
            We're currently moving through engineering, certification and
            preparation for controlled market pilots.
          </p>
        </motion.p>
      </div>
    </section>
  );
}
